import React from 'react';
import PropTypes from 'prop-types';

const TeamView = ({ data }) => {
  const eyebrow = data?.eyebrow || '';
  const title = data?.title || '';
  const variant = data?.variant || 'default';
  const columns = data?.columns || '4';
  const items = Array.isArray(data?.items) ? data.items : [];

  const cls = [
    'ag-team',
    `ag-team--${variant}`,
    `ag-team--cols-${columns}`,
  ].join(' ');

  return (
    <section className={cls}>
      <div className="ag-team__container">
        {(eyebrow || title) && (
          <header className="ag-team__header">
            {eyebrow && <div className="ag-team__eyebrow">{eyebrow}</div>}
            {title && <h2 className="ag-team__title">{title}</h2>}
          </header>
        )}
        {items.length > 0 && (
          <div className="ag-team__grid">
            {items.map((it, idx) => {
              const avatar = it?.avatar || '';
              const name = it?.name || '';
              const role = it?.role || '';
              const bio = it?.bio || '';
              const avatarStyle = avatar
                ? { backgroundImage: `url(${avatar})` }
                : undefined;
              return (
                <article className="ag-team__card" key={`team-${idx}`}>
                  <div
                    className={`ag-team__avatar${
                      avatar ? ' ag-team__avatar--photo' : ''
                    }`}
                    style={avatarStyle}
                    aria-hidden="true"
                  />
                  <div className="ag-team__body">
                    {name && <p className="ag-team__name">{name}</p>}
                    {role && <p className="ag-team__role">{role}</p>}
                    {bio && <p className="ag-team__bio">{bio}</p>}
                  </div>
                </article>
              );
            })}
          </div>
        )}
      </div>
    </section>
  );
};

TeamView.propTypes = {
  data: PropTypes.shape({
    eyebrow: PropTypes.string,
    title: PropTypes.string,
    variant: PropTypes.string,
    columns: PropTypes.string,
    items: PropTypes.array,
  }).isRequired,
};

export default TeamView;
